<template>
  <tr>
    <th class="type_top">
      전송 주기
      <span v-if="required" class="required">*</span>
    </th>
    <td>
      <input type="radio" :id="`daily_send_${uuid}`" :name="`send_type_${uuid}`" value="DAILY" v-model="period_local" />
      <label :for="`daily_send_${uuid}`">매일</label>
      <input type="radio" :id="`pick_send_${uuid}`" :name="`send_type_${uuid}`" value="DAY_OF_WEEK" v-model="period_local" />
      <label :for="`pick_send_${uuid}`">요일별</label>
      <div v-if="period_local === 'DAY_OF_WEEK'" class="form_wrap">
        <span class="form_title"> <span class="bracket">▸</span> 요일 선택 : </span>
        <span class="form_group type_check" v-for="(v, i) in dayLabelArray">
          <input type="checkbox" class="form_check" :id="`p_${i}_${uuid}`" :key="`p_${i}_${uuid}`" v-model="dayOfWeek_local[i]" />
          <label class="form_label" :for="`p_${i}_${uuid}`" :key="`l_${i}_${uuid}`">{{ dayLabelArray[i] }}</label>
        </span>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    period: {
      type: String,
      default: 'DAILY',
    },
    dayOfWeek: {
      type: Array,
      default: _.times(7, () => true),
    },
    required: Boolean,
  },
  data() {
    const dayOfWeek_local = this.dayOfWeek;
    _.times(7, (i) => {
      dayOfWeek_local[i] = dayOfWeek_local[i] || false;
    });
    return {
      dayLabelArray: '월화수목금토일'.split(''),
      period_local: this.period,
      dayOfWeek_local,
    };
  },
  watch: {
    period_local(val) {
      this.$emit('update:period', val);
      if (val) this.dayOfWeek_local = _.times(7, () => true);
    },
    dayOfWeek_local(val) {
      this.$emit('update:dayOfWeek', val);
    },
  },
  methods: {
    validate() {
      if (this.period === 'DAY_OF_WEEK' && !this.dayOfWeek.some((val) => !!val)) {
        alert('소식 전송할 요일을 선택해 주세요.');
        this.$el.querySelector('input.form_check').focus();
        return false;
      }
      return true;
    },
  },
};
</script>

<style></style>
